import { Link } from "react-router-dom";

import usePageTitle from "../hooks/usePageTitle";

function FaqSection() {
  usePageTitle(`FAQs | Fudopia | Meet. Eat. Repeat.`);

  return (
    <section>
      <h1>Frequently Asked Questions</h1>
      <div className="section faqs">
        <div style={{ textAlign: "left" }}>
          <h3>1. What is Fudopia?</h3>
          <p>
            Fudopia is a social foodie app where people meet up in small groups
            (max 4 people) to try new dishes and drinks together at restaurants,
            cafés, and bars around the city. It’s all about food, connection,
            and a bit of adventure.
          </p>
        </div>

        <div>
          <h3>2. How do the events work?</h3>
          <p>
            You can join an existing meetup or create your own. Pick a dish or
            drink, choose a suggested spot, and add your event details. Events
            can be discovered through dish, drink, or venue pages.
          </p>
        </div>

        <div>
          <h3>3. Why does each event have only one dish?</h3>
          <p>
            Each event features one dish or drink chosen by the host. It gives
            the group a shared starting point, something to talk about and try
            together. But it’s not a rule. Everyone can order more food or
            drinks, or stick to their own if they prefer not to share. It’s all
            about making things simple, social, and low-pressure.
          </p>
        </div>

        <div>
          <h3>4. Is Fudopia free?</h3>
          <p>
            Yes! We're offering{" "}
            <strong>full access free for our first 200 users</strong>. No
            payment needed for an entire year.
            <br />
            <br />
            That means you can create and join events, browse dishes, drinks,
            and places, and connect with other food lovers without any
            subscription fees.
            <br />
            <br />
            <a href="/register" className="text-blue-600 underline">
              Join now
            </a>{" "}
            and be one of the first!
          </p>
        </div>

        <div>
          <h3>5. How do I know who else is coming?</h3>
          <p>
            Each event shows who’s attending, along with their bios and favorite
            foods. A message board opens 3 hours before the event so you can
            chat and coordinate details.
          </p>
        </div>

        <div>
          <h3>6. Can I host my own event?</h3>
          <p>
            Definitely! As a member, you can create your own food meetup, choose
            a dish or drink and a place to try it, and invite others to join.
            It's a great way to bring people together over your favorite
            flavors.
          </p>
        </div>

        <div>
          <h3>7. What if I want to leave an event I joined?</h3>
          <p>
            No problem, things come up! You can leave an event before it starts.
            Just try to give a bit of notice so your fellow foodies aren’t left
            hanging.
          </p>
        </div>

        <div>
          <h3>8. Is there an age limit?</h3>
          <p>
            Yes, users must be at least 20 years old to join Fudopia. We want to
            make sure all events feel safe and appropriate for everyone.
          </p>
        </div>

        <div>
          <h3>
            9. Why are some events labeled as a Girls Meetup or Guys Meetup?
          </h3>
          <p>
            Some hosts choose to create events with a specific group vibe in
            mind, like a Girls Meetup or a Guys Meetup. These labels are set by
            the host to shape the experience they want to offer. We don’t
            enforce or verify these preferences, but we do ask everyone to
            respect the intention behind them. For example, if it’s a Girls
            Meetup, please only join if you identify as a woman. If you’re ever
            unsure or have feedback, feel free to reach out to us directly.
          </p>
        </div>

        <div>
          <h3>10. Is it safe to meet up with strangers?</h3>
          <p>
            All events are limited to 4 people to keep things personal and
            comfortable. You can view attendee profiles before the event, and
            the message board helps everyone connect beforehand. We also
            encourage meeting in public, well-reviewed restaurants, cafés, or
            bars.
          </p>
        </div>

        <div>
          <h3>11. What if I have dietary restrictions or allergies?</h3>
          <p>
            Since each event is tied to a specific dish or drink and location,
            you’ll know what’s being served before joining. If you have dietary
            concerns, it’s a good idea to check the restaurant’s menu or contact
            them directly. Fudopia doesn’t take responsibility for food
            allergies, so please only join events that feel safe for you.
          </p>
        </div>

        <div>
          <h3>12. Where is Fudopia available?</h3>
          <p>
            We’re starting in <strong>Bangkok</strong>, but plan to expand to
            other cities soon! If you’d like to see Fudopia in your city, let us
            know, we’re always hungry for the next destination.
          </p>
        </div>

        <div>
          <h3>13. Do you suggest all the dishes available in Bangkok?</h3>
          <p>
            Of course not, but we’re working on it! We handpick a variety of
            dishes and drinks to highlight some of the most exciting or iconic
            options, and we’re constantly adding more. Same goes for
            restaurants. If you have a favorite we’re missing,{" "}
            <Link to="/contact" style={{ textDecoration: "underline" }}>
              let us know
            </Link>
            !
          </p>
        </div>

        <div>
          <p>
            Still have questions?{" "}
            <Link to="/contact" style={{ textDecoration: "underline" }}>
              Reach out to us
            </Link>
            , we’re happy to help!
          </p>
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
